import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { ActionIcon, Box, Button, Menu } from '@mantine/core'
import { IconDots } from '@tabler/icons-react'
import { randomArrayItem } from '@utils/randomArrayItem'
import { StageListItem } from '@components/StageList/StageList'
import classes from '@styles/record.module.css'
import cn from 'classnames'
import ExampleUser from '@assets/exampleUser.png'
export interface TasksProps {
  fullWidth?: boolean
  state?: { history: any }
}

export const Tasks = (props: TasksProps) => {
  const { fullWidth, state } = props

  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = () =>
    navigate(
      `../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`,
      location?.state?.history
        ? { state: location?.state }
        : state
        ? { state }
        : {},
    )

  const data = Array(30)
    .fill(0)
    .map((_, i) => ({
      id: `invite-${i}`,
      record: (
        <DataGridPerson
          name="Joey Cadle"
          image={ExampleUser}
          status="online"
          onClick={handleNavigate}
        />
      ),
      assignedTo: (
        <DataGridPerson
          name="Alfredo Carrillo"
          status="online"
          onClick={handleNavigate}
        />
      ),
      type: randomArrayItem(['Call', 'Meet']),
      notes: randomArrayItem([
        'Let him know how special he is.',
        'Don’t forget to bring presents.',
        'Remind him to take care of him...',
        'Don’t forget that thing that was ...',
      ]),
      priority: randomArrayItem(['Urgent', 'High', 'Normal', 'Low']),
      date: 'Dec 1, 2024',
      time: '2:30pm',
    }))

  const fullWidthCols = fullWidth
    ? [
        {
          label: 'Record',
          prop: 'record',
          defaultSort: true,
          pinned: true,
        },
        {
          label: 'Assigned To',
          prop: 'assignedTo',
          pinned: true,
        },
      ]
    : [
        {
          label: 'Assigned To',
          prop: 'assignedTo',
          defaultSort: true,
          pinned: true,
        },
      ]
  const columns: DataGridColumns[] = [
    ...fullWidthCols,
    {
      label: 'Type',
      prop: 'type',
    },
    {
      label: 'Notes',
      prop: 'notes',
    },
    {
      label: 'Priority',
      prop: 'priority',
    },
    {
      label: 'Due Date',
      prop: 'date',
    },
    {
      label: 'Time',
      prop: 'time',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Tasks',
      href: '#',
      default: true,
    },
    {
      label: 'My Tasks',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Mark complete',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Edit',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Delete',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Mark complete',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item color="red">Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  const stages: StageListItem[] = [
    {
      name: 'Total',
      count: 4,
    },
    {
      name: 'Today',
      count: 4,
    },
    {
      name: 'Call',
      count: 1,
    },
    {
      name: 'Meet',
      count: 1,
    },
    {
      name: 'Email',
      count: 1,
    },
    {
      name: 'Action Item',
      count: 1,
    },
  ]

  return (
    <Box className={cn({ [classes.Record__content]: !fullWidth })}>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        results={data.length}
        stages={stages}
        buttons={<Button>Add Task</Button>}
        selectedActions={selectedActions}
        page={1}
      />
    </Box>
  )
}
